import { render, staticRenderFns } from "./FloatingActionButton.vue?vue&type=template&id=318110a0&scoped=true&"
import script from "./FloatingActionButton.vue?vue&type=script&lang=js&"
export * from "./FloatingActionButton.vue?vue&type=script&lang=js&"
import style0 from "./FloatingActionButton.vue?vue&type=style&index=0&id=318110a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318110a0",
  null
  
)

export default component.exports